import {connectionsService} from 'services';


export const SET_CURRENT_CONNECTION = 'SET_CURRENT_CONNECTION';
export const SET_CURRENT_CONNECTION_ID = 'SET_CURRENT_CONNECTION_ID';

const connectionsStore = {
  namespaced: true,
  state () {
    return {
      currentConnection: null
    };
  },
  getters: {
    currentConnection: (state) => state.currentConnection
  },
  mutations: {
    [SET_CURRENT_CONNECTION] (state, connection) {
      state.currentConnection = connection;
    }
  },
  actions: {
    async [SET_CURRENT_CONNECTION_ID] (context, connectionId) {
      if (!connectionId) {
        context.commit(SET_CURRENT_CONNECTION, null);
        return;
      }
      const connection = await connectionsService.get(context.rootGetters['accounts/currentAccountId'], connectionId);
      context.commit(SET_CURRENT_CONNECTION, connection);
    }
  }
};

export default connectionsStore;


